/**
 * Splits a Vite `?raw` source string on `// #region <id>` markers into a map
 * of id to the snippet between the markers, with the markers stripped and
 * shared indent removed.
 */
export const parseUsageRegions = (source: string): Record<string, string> => {
    const regions: Record<string, string> = {};
    const pattern = /\/\/ #region (\S+)[ \t]*\r?\n([\s\S]*?)\/\/ #endregion/g;
    for (const match of source.matchAll(pattern)) {
        const id = match[1];
        const body = match[2];
        if (id === undefined || body === undefined) {
            continue;
        }
        regions[id] = dedentSnippet(body);
    }
    return regions;
};

const dedentSnippet = (body: string): string => {
    const lines = body.replace(/\r\n/g, "\n").replace(/\n$/, "").split("\n");
    const filledLines = lines.filter((line) => line.trim() !== "");
    const indent = filledLines.reduce((minimum, line) => {
        const leading = /^ */.exec(line)?.[0].length ?? 0;
        return Math.min(minimum, leading);
    }, Number.POSITIVE_INFINITY);
    const trimCount = Number.isFinite(indent) ? indent : 0;
    return lines
        .map((line) => line.slice(trimCount))
        .join("\n")
        .trim();
};
